import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PageHeaderComponent } from './page-header/page-header.component';
import { ErrorMessageComponent } from './error-message/error-message.component';
import { PageLoaderComponent } from './page-loader/page-loader.component';
import { ApplyNowHeaderComponent } from './apply-now-header/apply-now-header.component';
import { DropdownComponent } from './dropdown/dropdown.component';
import { NgxBootstrapModule } from '../../ngx-bootstrap/ngx-bootstrap.module';
import { RouterModule } from '@angular/router';
import { DisclaimerPopupComponent } from './disclaimer-popup/disclaimer-popup.component';
import { AccordionListComponent } from './accordion-list/accordion-list.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { PipesModule } from '../pipes/pipes.module';
import { SelectedLoanOfferComponent } from './selected-loan-offer/selected-loan-offer.component';
import { SuggestedDelearsComponent } from './suggested-delears/suggested-delears.component';
import { ScheduleAppointmentComponent } from './schedule-appointment/schedule-appointment.component';
import { DirectivesModule } from '../directives/directives.module';
import { DateInputComponent } from './date-input/date-input.component';
import { LazyLoadedImageComponent } from './lazy-loaded-image/lazy-loaded-image.component';
import { VehicleCardComponent } from './vehicle-card/vehicle-card.component';
import { RangeSliderComponent } from './range-slider/range-slider.component';
import { DemoModeComponent } from './demo-mode/demo-mode.component';
import { ToasterComponent } from './toaster/toaster.component';
import { CaptchaComponent } from './captcha/captcha.component';


@NgModule({
  imports: [
    CommonModule,
    NgxBootstrapModule,
    RouterModule,
    ReactiveFormsModule,
    FormsModule,
    PipesModule,
    DirectivesModule
  ],
  declarations: [
    PageHeaderComponent,
    ErrorMessageComponent,
    PageLoaderComponent,
    ApplyNowHeaderComponent,
    DropdownComponent,
    DisclaimerPopupComponent,
    AccordionListComponent,
    SelectedLoanOfferComponent,
    SuggestedDelearsComponent,
    ScheduleAppointmentComponent,
    DateInputComponent,
    LazyLoadedImageComponent,
    VehicleCardComponent,
    RangeSliderComponent,
    DemoModeComponent,
    ToasterComponent,
    CaptchaComponent
  ],
  exports: [
    PageHeaderComponent,
    ErrorMessageComponent,
    PageLoaderComponent,
    ApplyNowHeaderComponent,
    DropdownComponent,
    DisclaimerPopupComponent,
    AccordionListComponent,
    RouterModule,
    SelectedLoanOfferComponent,
    SuggestedDelearsComponent,
    ScheduleAppointmentComponent,
    DateInputComponent,
    LazyLoadedImageComponent,
    VehicleCardComponent,
    RangeSliderComponent,
    DemoModeComponent,
    ToasterComponent,
    CaptchaComponent
  ]
})
export class ComponentsModule { }



// WEBPACK FOOTER //
// ./src/app/shared/components/components.module.ts